// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GuardrailActionSchema = z.enum(['BLOCK','WARN','LOG'] as const);

export type GuardrailActionType = `${z.infer<typeof GuardrailActionSchema>}`

export default GuardrailActionSchema;
